import { render } from "./VHero.vue?vue&type=template&id=29c16824"
import script from "./VHero.vue?vue&type=script&lang=ts"
export * from "./VHero.vue?vue&type=script&lang=ts"

import "./VHero.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script